import { useState } from 'react'

import { RemoveAuthorization, RemoveAuthorizationVariables } from 'globalTypes'

import { gql, useMutation } from '@apollo/client'
import { Trans } from '@lingui/macro'
import AskUserConfirmation from 'Root/App/Dialog/ask-user-confirmation'

import RemoveButton from '../remove-button'
import RemoveUserAuthorizationAlert from '../remove-user-auth-alert'
import LevelButton from './LevelButton'

const REMOVE_AUTHORIZATION = gql`
  mutation RemoveAuthorization($id: ID!) {
    removeAuthorization(id: $id)
  }
`

const Authorization = ({ authorization, elementId }) => {
  const { id, user, value } = authorization
  const [openRemoveDialog, setOpenRemoveDialog] = useState(false)
  const [mutate, { loading }] = useMutation<
    RemoveAuthorization,
    RemoveAuthorizationVariables
  >(REMOVE_AUTHORIZATION, {
    refetchQueries: ['GetElementAuthorizationForUsers'],
  })

  const handleAuthorizationRemove = async () => {
    await mutate({
      variables: {
        id,
      },
    })

    setOpenRemoveDialog((openDialog) => !openDialog)
  }

  const onCloseFn = !loading
    ? () => setOpenRemoveDialog((openRemoveDialog) => !openRemoveDialog)
    : () => null

  return (
    <div
      className="flex flex-col justify-between gap-3 p-3 sm:flex-row sm:gap-1"
      key={user.id}
      role="listitem"
    >
      <div className="flex flex-row gap-2 flex-grow flex-wrap">
        <img
          alt={user.name}
          className="h-10 w-10 rounded-md"
          src={user.picture}
        />
        <div className="flex flex-col my-auto text-sm text-gray-600">
          <div className="font-medium">{user.name}</div>
          <div>{user.email}</div>
          {authorization?.authorizationGroup && (
            <span
              className="flex px-2 h-5 justify-center items-center text-xs font-semibold rounded-full text-green-800 bg-green-100 cursor-default"
              style={{ width: 'max-content' }}
            >
              <Trans>Gruppo:</Trans>{' '}
              {authorization.authorizationGroup.group?.name || ''}
            </span>
          )}
        </div>
      </div>

      <div className="flex flex-row gap-1 sm:flex-nowrap items-center">
        <LevelButton
          id={elementId}
          level={value}
          user={user.id}
          disabled={authorization?.authorizationGroup?.id}
        />

        {!authorization?.authorizationGroup?.id && (
          <RemoveButton onRemoveCallback={() => setOpenRemoveDialog(true)} />
        )}
      </div>

      {openRemoveDialog && (
        <AskUserConfirmation openDialog={openRemoveDialog} onClose={onCloseFn}>
          <RemoveUserAuthorizationAlert
            onConfirm={handleAuthorizationRemove}
            onClose={onCloseFn}
            isRemoving={loading}
          />
        </AskUserConfirmation>
      )}
    </div>
  )
}

export default Authorization
